import React, { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "./utils/store";
import { protectedRoutes } from "./utils/functions/routeConfig";
import { useRehydrateModules } from "./components/hooks/useRehydrateModules";
import ScrollToTop from "./components/common/ScrollToTop";
import AuthRoute from "./components/common/AuthRoute";
import ProtectedRoute from "./components/common/ProtectedRoute";
import ModuleProtectedRoute from "./components/common/ModuleProtectedRoute";
import RehydrationGuard from "./components/common/RehydrationGuard";
import Loader from "./components/common/Loader";
const Layout = lazy(() => import("./components/layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const LoginOtp = lazy(() => import("./pages/LoginOtp"));
const ChangePassword = lazy(() => import("./pages/ChangePassword"));
const SSORedirectHandler = lazy(() => import("./SSORedirectHandler"));

const App = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  useRehydrateModules();

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/sso-login" element={<SSORedirectHandler />} />
          <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
          <Route path="/forgot-password" element={<AuthRoute><ForgotPassword /></AuthRoute>} />
          <Route path="/otp" element={<AuthRoute><LoginOtp /></AuthRoute>} />
          <Route path="/change-password" element={<AuthRoute><ChangePassword /></AuthRoute>} />

          <Route path="/*" element={
            <ProtectedRoute>
              <RehydrationGuard>
                <Layout />
              </RehydrationGuard>
            </ProtectedRoute>}>
            {protectedRoutes.map(({ path, component: Component, moduleName, permission }) => {
              const element = moduleName && permission ? (
                <ModuleProtectedRoute moduleName={moduleName} permission={permission}>
                  <Component />
                </ModuleProtectedRoute>
              ) : (
                <Component />
              );

              return <Route key={path} path={path} element={element} />;
            })}
          </Route>

          <Route path="/*" element={<Navigate to={!token ? '/login' : '/dashboard'} replace />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
